import React from 'react'
import classnames from 'classnames'
import { Container, Row, Col } from 'react-bootstrap'
import PropTypes from 'prop-types'
import Header from '../../components/Header'
import Footer from '../../components/Footer'

const DefaultLayout = ({ pageTitle, children, wideContent, home }) => {
  const contentLayout = wideContent ? { xl: { span: 12, offset: 0 } } : { xl: { span: 8, offset: 2 } }

  return (
    <div className={classnames('default-layout', { 'default-layout--home': home })}>
      <Header />
      <Container>
        <Row>
          <Col className="content-wrapper" lg={{ span: 12, offset: 0 }} {...contentLayout}>
            { children }
          </Col>
        </Row>
        <Row>
          <Footer />
        </Row>
      </Container>
    </div>
  )
}

DefaultLayout.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  wideContent: PropTypes.bool,
  home: PropTypes.bool,
}

DefaultLayout.defaultProps = {
  wideContent: false,
  home: false,
}

export default DefaultLayout;
